/* @flow */
/* eslint no-unused-vars: 0 */

import React from 'react';

import ProductPagination from './pagination';
import ProductListings from './product_listings';
import ProductsPerPage from './per_page';
import ProductAggregations from './aggregations';
import ProductsSearchTitle from './products_search_title';
import ProductsLoading from './products_loading';
import ProductsNoResults from './products_no_results';
import ProductsError from './products_error';
import ProductSorting from './product_sorting';

class Products extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      error: false,
      no_results: false,
      aggregations: [],
      applied_aggregates: {},
      loading: false,
      loadingPrices: false,
      number_of_pages: 0,
      page: 1,
      per_page: this.defaultPerPageValue(props),
      per_page_options: [12, 24, 48],
      sort: '',
      sortDisplay: 'Relevance',
      products: [],
      prices: [],
      pricing_error: false,
      products_total: 0,
      q: '',
      query: {},
      display_aggregations: false,
      display_sort_by: false,
      allImages: [],
    };

    this.formatQuery = this.formatQuery.bind(this);
    this.freshSearch = this.freshSearch.bind(this);
    this.searchProducts = this.searchProducts.bind(this);

    // Prices
    this.getPrices = this.getPrices.bind(this);

    // Branch Stocks
    this.getBranchStocks = this.getBranchStocks.bind(this);

    // URL Parsing
    this.parseURL = this.parseURL.bind(this);
    this.parseURLAggregations = this.parseURLAggregations.bind(this);
    this.parseURLPageNumber = this.parseURLPageNumber.bind(this);
    this.parseURLPerPage = this.parseURLPerPage.bind(this);

    // Aggregations
    this.toggleAggregate = this.toggleAggregate.bind(this);
    this.resetAllAggregates = this.resetAllAggregates.bind(this);

    // Pagination
    this.setPage = this.setPage.bind(this);
    this.setPerPage = this.setPerPage.bind(this);
    this.validPageNumber = this.validPageNumber.bind(this);

    // Sorting
    this.setSort = this.setSort.bind(this);

    // Product Compare
    this.getCompareProducts = this.getCompareProducts.bind(this);

    this.toggle = this.toggle.bind(this);
    this.pushProductImpressions = this.pushProductImpressions.bind(this);
  }

  defaultPerPageValue(props) {
    let per_page;
    if (props.mobile === true) {
      per_page = 6;
    } else {
      per_page =
        $.cookie('product_listings_per_page') !== undefined
          ? parseInt($.cookie('product_listings_per_page'))
          : 12;
    }
    return per_page;
  }

  freshSearch(first_page = true) {
    const page = first_page === true ? 1 : this.state.page;
    this.setState({ page }, () => {
      this.searchProducts();
    });
  }

  formatQuery() {
    const q =
      this.props.mode === 'search'
        ? this.state.q
        : this.props.q && this.props.q.length
        ? this.props.q
        : '*';
    const query = {
      q,
      per_page: this.state.per_page,
      page: this.state.page,
    };

    if (this.state.sort !== '') {
      query.sort = this.state.sort;
    }

    if (this.props.mode === 'category') {
      query.category = this.props.category_ids;
      query.force_category = true;
    }

    if (this.props.mode === 'brand' && this.props.brand_id) {
      query.brand = this.props.brand_id;
      query.force_brand = true;
    } else if (this.props.mode === 'brand' && this.props.brand_id === null) {
      this.setState({ error: true });
    }

    Object.keys(this.state.applied_aggregates).forEach(key => {
      query[key] = this.state.applied_aggregates[key];
    });

    return query;
  }

  setSort(value) {
    this.setState(
      {
        sort: value,
      },
      () => {
        this.updateURLParam(value, 'sort');
      },
    );
  }

  updateURLParam(value, param_name, perform_search = true) {
    let current_params =
      window.location.search !== ''
        ? window.location.search
        : window.location.pathname;
    const param = `${param_name}=${value}`;
    const param_regex = new RegExp(`[?&]${param_name}=([^&#]*)`);

    if (window.location.search === '') {
      current_params += `?${param}`;
    } else {
      current_params =
        param_regex.test(window.location.search) == true
          ? current_params.replace(param_regex, `&${param}`)
          : `${current_params}&${param}`;
    }

    if (current_params[0] === '&') {
      current_params = current_params.replace('&', '?');
    }

    history.pushState(null, null, current_params);
    if (perform_search) {
      this.parseURL();
    }
  }

  parseURL() {
    const urlParameters = $.parseParams(window.location.search);
    if (urlParameters.q !== '' || urlParameters.q !== undefined) {
      this.setState(
        {
          q: urlParameters.q,
          page: this.parseURLPageNumber(urlParameters),
          per_page: this.parseURLPerPage(urlParameters),
          sort: this.parseURLSorting(urlParameters),
        },
        () => {
          this.parseURLAggregations(urlParameters);
          this.freshSearch(false);
        },
      );
    } else {
      this.setState({ error: true });
    }
  }

  parseURLAggregations(urlParameters) {
    const aggs = this.props.aggregations.slice();
    aggs.push('brand', 'category');

    this.setState({ applied_aggregates: {} }, () => {
      aggs.forEach(agg => {
        if (urlParameters[`${agg}[]`] !== undefined) {
          if (Array.isArray(urlParameters[`${agg}[]`])) {
            urlParameters[`${agg}[]`].forEach(agg_value => {
              this.toggleAggregate(agg, agg_value, false, false);
            });
          } else {
            this.toggleAggregate(agg, urlParameters[`${agg}[]`], false, false);
          }
        }
      });
    });
  }

  parseURLPageNumber(urlParameters) {
    return urlParameters.page !== undefined ? parseInt(urlParameters.page) : 1;
  }

  parseURLSorting(urlParameters) {
    const { mode } = this.props;

    if (urlParameters.sort !== undefined) {
      return urlParameters.sort;
    }

    if (mode === 'category') {
      return 'b2b_stock_level.sort_desc';
    }

    return '';
  }

  parseURLPerPage(urlParameters) {
    const perPage =
      urlParameters.per_page !== undefined
        ? parseInt(urlParameters.per_page)
        : this.state.per_page;
    return this.state.per_page_options.includes(perPage)
      ? perPage
      : this.defaultPerPageValue(this.props);
  }

  resetAllAggregates() {
    let current_params = window.location.search;
    const allAggs = this.props.aggregations.slice();
    allAggs.push('brand', 'category');
    allAggs.map(agg => {
      const param_array_regex = new RegExp(`[?&](${agg}[[]]=[^&#]*)`, 'g');
      const param_regex = new RegExp(`[?&](${agg}=[^&#]*)`, 'g');
      current_params = current_params.replace(param_array_regex, '');
      current_params = current_params.replace(param_regex, '');
    });

    current_params =
      current_params === '' ? window.location.pathname : current_params;

    history.pushState(null, null, current_params);
    this.parseURL();
  }

  toggleAggregate(
    agg_type,
    agg_value,
    perform_search = true,
    update_url = false,
  ) {
    agg_value = decodeURIComponentSafe(agg_value);
    const formatted_key = agg_type.replace(/ /g, '_');
    const param_regex = new RegExp(`[?&](${formatted_key}[]=${agg_value}*)`);
    const current = this.state.applied_aggregates;

    if (this.state.applied_aggregates[formatted_key] === undefined) {
      const applied = this.state.applied_aggregates;
      applied[formatted_key] = [agg_value];

      if (update_url) {
        this.addAggregateToURL(current, agg_value, formatted_key, true);
      }

      if (applied) {
        Object.keys(applied).forEach(key => {
          applied[key] = applied[key].filter((item, pos) => {
            return applied[key].indexOf(item) === pos;
          });
        });
      }

      this.setState(
        {
          applied_aggregates: applied,
        },
        () => {
          if (perform_search) {
            this.freshSearch(false);
          }
        },
      );
    } else {
      current[formatted_key].includes(agg_value) === true
        ? this.removeAggregateFromURL(
            current,
            agg_value,
            formatted_key,
            update_url,
          )
        : this.addAggregateToURL(current, agg_value, formatted_key, update_url);

      // Remove any empty values
      Object.keys(current).forEach(agg => {
        if (current[agg].length === 0) {
          delete current[agg];
        }
      });

      this.setState({ applied_aggregates: current }, () => {
        if (perform_search) {
          this.freshSearch(false);
        }
      });
    }
  }

  addAggregateToURL(current, agg_value, formatted_key, update_url) {
    if (update_url) {
      if (window.dataLayer) {
        window.dataLayer.push({
          event: 'ProductFiltering',
          list:
            this.props.mode === 'category' ? 'Category Page' : 'Search Results',
          searchUsed: this.state.q,
          'Filter type': formatted_key,
          'Filter used': agg_value,
          Category: this.props.title,
          checked: true,
        });
      }
      let current_params = `${
        window.location.search
      }&${formatted_key}[]=${encodeURIComponent(agg_value)}`;
      if (current_params[0] === '&') {
        current_params = current_params.replace('&', '?');
      }
      history.pushState(null, null, current_params);
    }
    current[formatted_key] = [...current[formatted_key], agg_value];
  }

  removeAggregateFromURL(current, agg_value, formatted_key, update_url) {
    if (update_url) {
      const param_regex = new RegExp(
        `[?&]${formatted_key}[[]]=${encodeURIComponent(agg_value).replace(
          /(?=[() ])/g,
          '\\',
        )}(?=$|&)`,
        'g',
      );
      if (window.dataLayer) {
        window.dataLayer.push({
          event: 'ProductFiltering',
          list:
            this.props.mode === 'category' ? 'Category Page' : 'Search Results',
          searchUsed: this.state.q,
          'Filter type': formatted_key,
          'Filter used': agg_value,
          Category: this.props.title,
          checked: false,
        });
      }
      let current_params = window.location.search.replace(param_regex, '');

      if (current_params[0] === '&') {
        current_params = current_params.replace('&', '?');
      }
      current_params =
        current_params === '' ? window.location.pathname : current_params;
      history.pushState(null, null, current_params);
    }
    current[formatted_key] = current[formatted_key].filter(
      item => item !== agg_value,
    );
  }

  validPageNumber() {
    return !(
      (this.state.page >
        Math.ceil(this.state.products_total / this.state.per_page) ||
        this.state.page <= 0 ||
        isNaN(this.state.page)) &&
      this.state.products_total > 0
    );
  }

  getBranchStocks() {
    if (this.props.collection_store_set) {
      const products = this.state.products.map(p => parseInt(p.id));
      $.ajax({
        url: '/catalogue/products/branch_stocks',
        dataType: 'json',
        data: {
          products,
        },
        success: branchStocks => {
          this.setState({ branchStocks });
        },
        error: error => {
          this.setState({
            branchStocks: [],
          });
        },
      });
    }
  }

  getPrices() {
    this.setState({ loadingPrices: true });
    if (this.props.signed_in === true) {
      const products = this.state.products.map(p => p.id).join(',');
      $.ajax({
        url: '/product_price',
        data: { products },
        dataType: 'JSON',
        success: prices => {
          this.setState({ prices, loadingPrices: false });
          this.pushProductImpressions();
        },
        error: () => {
          this.setState({ pricing_error: true, loadingPrices: false });
        },
      });
    } else {
      this.setState({ pricing_error: true, prices: [], loadingPrices: false });
      this.pushProductImpressions();
    }
  }

  pushProductImpressions() {
    const { products, prices } = this.state;
    const { mode } = this.props;

    dataLayer.push({
      event: 'productImpressions',
      ecommerce: {
        currencyCode: 'GBP',
        impressions: products.map((product, index) => ({
          id: product.stock_code,
          brand: product.brand,
          name: product.brand_and_description_short,
          position: index + 1,
          price: prices[product.id].price,
          list: mode === 'search' ? 'Search Results' : 'Category Page',
          category: product.primary_root_category,
          'id-variant': product.id,
        })),
      },
    });
  }

  searchProducts() {
    this.setState({
      loading: true,
      no_results: false,
      prices: [],
      pricing_error: false,
    });
    const query = this.formatQuery();

    $.ajax({
      url: '/catalogue/products/search',
      data: query,
      dataType: 'JSON',
      success: data => {
        this.setState(
          {
            products_total: data.total,
            products: data.products,
            aggregations: data.aggregations,
            loading: false,
          },
          () => {
            const allImages = document.querySelectorAll(
              '.image__list-lazy-image',
            );
            this.setState({
              allImages,
            });

            if (this.validPageNumber() === false) {
              this.setPage(1);
            }

            if (this.state.products_total === 0) {
              this.setState({ no_results: true });
            }

            const { sort } = this.state;
            const { sorting_options: sortingOptions } = this.props;
            const sortedOption = sortingOptions.filter(
              option => option.value === sort,
            );

            this.setState({
              sortDisplay: sortedOption[0].display,
            });

            this.getPrices();
            this.getBranchStocks();
          },
        );
      },
      error: () => {
        this.setState({ error: true });
      },
    });
  }

  setPerPage(count) {
    if (this.state.per_page_options.includes(count)) {
      $.cookie('product_listings_per_page', count);
      this.updateURLParam(count, 'per_page', false);
      this.updateURLParam(1, 'page');
    }
  }

  setPage(count, scroll_to_top = false) {
    this.setState({ page: count }, () => {
      this.updateURLParam(count, 'page');
      const target = document.querySelector('.products--sorting');
      if (scroll_to_top && target) {
        $('body, html').animate(
          {
            scrollTop: target.offsetTop,
          },
          600,
        );
      }
    });
  }

  getCompareProducts() {
    $.ajax({
      url: '/products_compare',
      method: 'GET',
      dataType: 'JSON',
      success: products => {
        PubSub.publish('PRODUCT-COMPARE-ADDED', products);
      },
    });
  }

  toggle(option) {
    const newState = {};
    newState[option] = !this.state[option];
    const html = document.getElementsByTagName('html')[0];
    html.classList.toggle('disable-scroll');
    document.body.classList.toggle('disable-scroll');

    this.setState(newState);
  }

  componentDidMount() {
    if (this.props.num_compare_products > 0) {
      this.getCompareProducts();
    }
    this.parseURL();
    window.onpopstate = () => {
      this.parseURL();
    };
  }

  render() {
    const {
      basket,
      marketing_text: marketingText,
      b2b_phone_number: b2bPhoneNumber,
      customer_services_email: customerServicesEmail,
    } = this.props;

    if (this.state.error) {
      return <ProductsError assets={this.props.assets} />;
    }
    if (this.state.no_results) {
      return (
        <ProductsNoResults
          customerServicesEmail={customerServicesEmail}
          query={this.state.q}
          b2bPhoneNumber={b2bPhoneNumber}
          assets={this.props.assets}
          applied_aggregates={this.state.applied_aggregates}
          resetAllAggregates={this.resetAllAggregates}
          mode={this.props.mode}
          brand_name={this.props.brand_name}
        />
      );
    }
    return (
      <div>
        <ProductsLoading loading={this.state.loading} />
        <div className="row-fluid">
          <div className="span3 filters--area">
            <div className="row-fluid mobile--toggles visible-phone">
              <a
                href="#"
                className="toggle toggle--filters"
                onClick={e => {
                  e.preventDefault();
                  this.toggle('display_aggregations');
                }}>
                Filters
                {Object.keys(this.state.applied_aggregates).length > 0 ? (
                  <span>
                    ({Object.keys(this.state.applied_aggregates).length})
                  </span>
                ) : (
                  ''
                )}
              </a>
              <a
                href="#"
                className="toggle toggle--sort-by"
                onClick={e => {
                  e.preventDefault();
                  this.toggle('display_sort_by');
                }}>
                Sort By
              </a>
            </div>

            <ProductAggregations
              aggregations={this.state.aggregations}
              products_total={this.state.products_total}
              applied_aggregates={this.state.applied_aggregates}
              assets={this.props.assets}
              toggleAggregate={this.toggleAggregate}
              resetAllAggregates={this.resetAllAggregates}
              mode={this.props.mode}
              mobile_display={this.state.display_aggregations}
              toggle={this.toggle}
            />
          </div>

          <div className="span9 products--area">
            <div
              className={`row-fluid products--options ${
                this.state.display_sort_by === false ? 'hidden-phone' : ''
              }`}>
              <div className="span6">
                <ProductSorting
                  setSort={this.setSort}
                  sorting_options={this.props.sorting_options}
                  mode={this.props.mode}
                  mobile_display={this.state.display_sort_by}
                  toggle={this.toggle}
                  assets={this.props.assets}
                  mobile={this.props.mobile}
                  guest={this.props.guest}
                  sortDisplay={this.state.sortDisplay}
                />
              </div>
              <div className="span6 hidden-phone">
                <ProductsPerPage
                  setPerPage={this.setPerPage}
                  per_page_options={this.state.per_page_options}
                  per_page={this.state.per_page}
                />
              </div>
            </div>

            <div className="row-fluid products--pagination">
              <div className="span12">
                <ProductPagination
                  products_total={this.state.products_total}
                  per_page={this.state.per_page}
                  current_page={this.state.page}
                  setPage={this.setPage}
                  mobile={this.props.mobile}
                  assets={this.props.assets}
                />
              </div>
            </div>
            <ProductListings
              currentStore={this.props.collection_store || {}}
              selectAStoreUrl={this.props.selectAStoreUrl}
              assets={this.props.assets}
              products={this.state.products}
              prices={this.state.prices}
              branchStocks={this.state.branchStocks}
              pricing_error={this.state.pricing_error}
              collectionSet={this.props.collection_store_set}
              vat_exclusive={this.props.vat_exclusive}
              loadingPrices={this.state.loadingPrices}
              allImages={this.state.allImages}
            />
            <div className="row-fluid products--pagination">
              <div className="span12">
                <ProductPagination
                  products_total={this.state.products_total}
                  per_page={this.state.per_page}
                  current_page={this.state.page}
                  setPage={this.setPage}
                  mobile={this.props.mobile}
                  assets={this.props.assets}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Products;
